import React from 'react'
import PropTypes from 'prop-types'
import { Divider as AntDDivider } from 'antd'
import withStyle from './Divider.style.js'

const Divider = ({ type, dashed, className, orientation, style }) => (
  <AntDDivider
    type={type}
    dashed={dashed}
    className={
      typeof className === 'string'
        ? `chec-table-row ${className}`
        : (record, index) => `chec-table-row ${className(record, index)}`
    }
    orientation={orientation}
    style={style}
  />
)

Divider.defaultProps = {
  type: 'horizontal',
  dashed: false,
  className: '',
  orientation: 'center',
  collapseMargins: false,
}

Divider.propTypes = {
  type: PropTypes.oneOf(['horizontal', 'vertical']),
  dashed: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  orientation: PropTypes.oneOf(['left', 'right', 'center']),
  style: PropTypes.object,
  collapseMargins: PropTypes.bool,
}

export default withStyle(Divider)
